import qs from 'qs';
import { ProjectIssueRootCause } from '../model/entities';
import { proxyApiAxios } from './CustomAxios';
import providerAuthService from '../services/ProviderAuthService';

class ProjectIssueRootCauseApi {
    list = async (hubId: string, projectId: string[]): Promise<ProjectIssueRootCause[]> => {
        const headers = await providerAuthService.getRequestHeader('ACC');
        const response = await proxyApiAxios.get<ProjectIssueRootCause[]>('/project-issue-root-causes', {
            params: { hubId, projectId },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
            headers,
        });

        return response.data;
    };
}

const projectIssueRootCauseApi: ProjectIssueRootCauseApi = new ProjectIssueRootCauseApi();
export default projectIssueRootCauseApi;
